<rotec-form-v2
  [form]="stepForm"
  (formChange)="stepForm = $event"
  [fields]="schedulingFields"
  [model]="toolingTaskModel"
  (modelChange)="toolingTaskModelChange.emit($event)"
>
</rotec-form-v2>
